// API Configuration
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_URL || '',
  API_BASE: process.env.REACT_APP_API_URL
    ? `${process.env.REACT_APP_API_URL}/api`
    : '/api'
};

// Log API configuration for debugging
console.log('API Configuration:', {
  BASE_URL: API_CONFIG.BASE_URL,
  API_BASE: API_CONFIG.API_BASE,
  REACT_APP_API_URL: process.env.REACT_APP_API_URL || 'Not set'
});

export default API_CONFIG;
